import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-lock-password-Bulk',
  standalone: true,
  templateUrl: '../../assets/lock-password/Bulk.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamLockPasswordBulkIcon {}
